<template>
    <DocumentList :docs="downloads"></DocumentList>
</template>
<script>
    import DocumentList from "../components/DocumentList";
    export default {
        components: {DocumentList},
        mounted () {
            this.$store.commit('SET_TITLE', 'Downloads')
        },
        computed: {
            downloads () {
                return this.$store.state.downloads
            }
        }
    }
</script>
<style scoped>

</style>